import { Component, OnInit, Input, Inject, OnDestroy, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { ForumService } from "../../services/forum.service"
import { forumdetails } from 'src/app/models/forum';
import { PageScrollService } from 'ngx-page-scroll-core';
import { DOCUMENT } from '@angular/common';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { ComponentheaderService } from 'src/app/services/componentheader.service';
import { UseraccessserviceService } from 'src/app/services/useraccessservice.service';
import { ModulemanagementService } from 'src/app/services/modules/modulemanagement.service';
import { SchoolmanagementService } from 'src/app/services/schoolmanagement.service';

@Component({
  selector: 'app-forum',
  templateUrl: './forum.component.html',
  styleUrls: ['./forum.component.css']
})
export class ForumComponent implements OnInit, AfterViewInit, OnDestroy {
  newquestion: forumdetails = new forumdetails();
  parent = new forumdetails();
  forumquestions: forumdetails[];
  id: number;
  moduleid: number = 0;
  //currentuser: string;
  moduleinfo: any
  schoolinfo: any
  screenSizeIsMediumAndAbove: boolean;
  chatSectionLabel: string;
  getDiscussionsintervalId?: NodeJS.Timeout;
  @ViewChild('forumContainer') forumContainer: ElementRef;
  parentId: any;
  loading: boolean = true; //used to deactivate send button
  breadcrumb: number; //used in logic that fixes bug when trying to navigate from child discussion
  previousid: number = 0;
  constructor(private forumservice: ForumService, private modulemanager: ModulemanagementService, public headerinfo: ComponentheaderService, private user: UseraccessserviceService, private pageScrollService: PageScrollService, @Inject(DOCUMENT) private document: any, private router: ActivatedRoute, private route: Router, private schoolmanager: SchoolmanagementService) {
    headerinfo.setHeaderDisplay('Forum', [], []);
    this.checkIfScreeSizeIsMediumAndAbove = this.checkIfScreeSizeIsMediumAndAbove.bind(this);
  }

  ngOnInit(): void {
    // this.id = this.router.snapshot.params['id'];   
    this.urlSubsription();

    this.pageScrollService.scroll({
      document: this.document,
      scrollTarget: '.theEnd',
    });

    this.checkIfScreeSizeIsMediumAndAbove();
    window.addEventListener('resize', this.checkIfScreeSizeIsMediumAndAbove);
  }

  ngAfterViewInit(): void {    
    this.setDiscussionInterval();   
  }

  scrollToTop(){ //used for topics
    this.forumContainer.nativeElement.scrollTo({left: 0, top: 0, behavior: 'smooth'});
  }
  scrollToBottom(){ //used for discussion
    setTimeout(() => {
      this.forumContainer.nativeElement.scrollTo({left: 0, top: this.forumContainer.nativeElement.scrollHeight, behavior: 'smooth'});
    }, 0);
  }

  ngOnDestroy(): void {
    window.removeEventListener('resize', this.checkIfScreeSizeIsMediumAndAbove);
    if (this.getDiscussionsintervalId) {
      clearInterval(this.getDiscussionsintervalId);
      this.getDiscussionsintervalId = undefined;
    }
  }

  checkIfScreeSizeIsMediumAndAbove() {
    this.screenSizeIsMediumAndAbove = window.matchMedia('(min-width: 768px)').matches;
  }

  urlSubsription() {
    this.loading = true;
    this.router.queryParams.subscribe(routeParams => {     
      let moduleid: number = 0;
      let parentid: number = 0;
      this.breadcrumb = routeParams.breadcrumb;
      let breadcrumb = this.breadcrumb;
      
      this.chatSectionLabel = 'Add New Topic';
      if (routeParams.parentcommentid > 0) {
        parentid = this.parentId = routeParams.parentcommentid;
        this.chatSectionLabel = 'Add Reply';        
      }
      if (routeParams.moduleid > 0) {
        moduleid = routeParams.moduleid;
        this.moduleid = moduleid;
      }           

      if (this.breadcrumb == 1 && breadcrumb != 2){ // value of 1 comes from breadcrumb routing while value of 2 is later set so as to prevent loading all the comment
        this.previousid = 0; // setting to 0 will load all the comments (in later part of the work flow)
        this.parentId = null;
      }

      this.getdiscussions(moduleid, parentid)
      this.id = parentid;     
    });
    this.loading = false;
  }

  addQuestion() {
    if (!this.newquestion.text.trim()) {
      return false;
    }

    let parent = new forumdetails();
    console.log(this.id);
    if (this.id > 0) {
      parent = this.forumquestions.filter(q => q.id == this.id)[0];
    }
    this.newquestion.datePosted = new Date();
    // this.newquestion.datePosted = "Wednesday,24th July 2020";
    this.newquestion.dateoflastupdate = new Date().toUTCString();
    this.newquestion.noOfReplies = 0;
    this.newquestion.noofthumbsdown = 0;
    this.newquestion.noofthumbsup = 0;
    
    this.newquestion.quoteSummary = "";
    this.newquestion.parentcreateddate = new Date(parent.datePosted);
    
    this.newquestion.quoteID = this.id;
    this.newquestion.moduleID = this.moduleid;
    //this.newquestion.id = this.id + 1;
    this.forumservice.addquestion(this.newquestion).subscribe(
      (data: any) => {
        this.urlSubsription();
        this.newquestion = new forumdetails();
      },
      (error: HttpErrorResponse) => {
        if (error.status === 0) {
          console.log("Unable to connect to server");
        }
        else if (error.status === 400) {
          console.log(error.error.message);
        }
      }
    );
  }

  setbreadcrumbs(parentid:any)
  {
    this.modulemanager.getModuleDetails(this.moduleid).subscribe(
      (data: any) => {
        this.moduleinfo = data.moduleinfo;
        if (parentid == 0) {
          this.headerinfo.setHeaderDisplay(
            "Forum",
            [
              // { displaytext: data.schoolName, route: `/user/schoolhome`, params: { schoolID: this.moduleinfo.schoolID } },
              // { displaytext: this.moduleinfo.name, route: `/user/moduledetails`, params: { moduleID: this.moduleid } },
              { displaytext: 'School', route: `/user/schoolhome` },
              { displaytext: 'Course', route: `/user/moduledetails`, params: { moduleID: this.moduleid } },
              { displaytext: "Forum", route: `/user/forum`, params: { moduleid: this.moduleid } },
            ],
            []);
        }
        else {
          this.headerinfo.setHeaderDisplay(
            "Forum",
            [
              // { displaytext: data.schoolName, route: `/user/schoolhome`, params: { schoolID: this.moduleinfo.schoolID } },
              // { displaytext: this.moduleinfo.name, route: `/user/moduledetails`, params: { moduleID: this.moduleid } },
              { displaytext:'School', route: `/user/schoolhome` },
              { displaytext: 'Course', route: `/user/moduledetails`, params: { moduleID: this.moduleid } },
              { displaytext: "Forum", route: `/user/forum`, params: { moduleid: this.moduleid, breadcrumb: 1 } },
              { displaytext: 'Current Discussion', route: `/user/forum`, params: this.router.snapshot.queryParams },
            ],
            []);
        }
      },
      (err: HttpErrorResponse) => {
        console.log(JSON.stringify(err));
      }
    );
  }

  getdiscussions(moduleid: number, parentid: number) {
    // this.forumservice.getAllComments().subscribe(
    //   data=>{this.forumquestions=data})
    this.loading = true;
    let pId = this.previousid;
    if (parentid > 0 || moduleid > 0) {
      
      this.forumservice.getCommentsById(parentid, moduleid, 0, pId).subscribe(f => {
        console.log("the retrieved forum comment" + this.forumquestions);
        this.setForumQuestions(f, pId);
        this.setParent(parentid)
        if ((this.forumquestions == null || this.forumquestions.length == 0 || this.forumquestions == undefined) && moduleid == 0) {
          this.route.navigate(['user/forum'], { queryParams: { 'moduleid': moduleid } });
        }        
      });
    }
    if ((parentid == 0 || parentid == undefined) && moduleid == 0) {
      this.forumservice.getAllComments().subscribe(f => {
        this.setForumQuestions(f, pId);   
        
      });
    }  
    // previouscommentId will be only on init, this ensure that the breadcrumb is set once
    if(pId == 0)  {
      this.setbreadcrumbs(parentid);
      this.breadcrumb = 2;        
    }
    this.loading = false;
  }

  setDiscussionInterval(){
    this.getDiscussionsintervalId = setInterval(() => {
      this.urlSubsription()
    }, 120000); 
  }
  setForumQuestions(f: forumdetails[], previousId: number){
    if(f.length > 0){
      if(previousId === 0){ // on first load, all the previous comments will be loaded. Datetime is expected to be 0
        this.forumquestions = f;
      }
      else{
        if(this.parentId){
          f.forEach(element => {
            if (this.forumquestions.find(q => q.id !== element.id)){
              this.forumquestions.push(element);
            }
          });
          this.scrollToBottom();
        }
        else{          
          f.forEach(element => {
            if(this.forumquestions === undefined){
              this.forumquestions = new Array<forumdetails>;
            }
            this.forumquestions.unshift(element);
          });        
          this.scrollToTop();
        }
                  
      }       
      this.previousid = Math.max(...f.map(item => item.id));
    }    
  }
  setParent(parentid: number) {
    if (parentid > 0) {
      this.parent = this.forumquestions.filter(q => q.id == this.id)[0];
      console.log("Parent: " + this.parent);
    }
  }

  clearcommenttextarea(clear: boolean) {
    if (clear) {
      this.newquestion = new forumdetails();
    }
  }

  onReplyClicked(reset: boolean){
    if(reset)
      this.previousid = 0;
  }
  deletediscussion(id: number) {
    this.forumservice.deletequestionById(id).subscribe(
      (data: any) => {
        console.log(data);
        console.log(this.router.snapshot.queryParams.moduleid);
        
        if (this.router.snapshot.queryParams.parentcommentid == undefined || (this.router.snapshot.queryParams.parentcommentid == id && this.router.snapshot.queryParams.parentcommentid != undefined)) {
          this.getdiscussions(this.moduleid, 0);
        }
        else {
          if (this.router.snapshot.queryParams.parentcommentid != id) this.getdiscussions(0, this.router.snapshot.queryParams.parentcommentid);
        }


      },
      (error: HttpErrorResponse) => {
        if (error.status === 0) {
          console.log("Unable to connect to server");
        }
        else if (error.status === 400) {
          console.log(error.error.message);
        }
      }
    );
  }

  updateComment(comment: forumdetails) {
    comment.quoteSummary = "";
    this.forumservice.addquestion(comment).subscribe(
      (data: any) => {
        console.log(data);
        this.urlSubsription();
        this.newquestion = new forumdetails();
      },
      (error: HttpErrorResponse) => {
        if (error.status === 0) {
          console.log("Unable to connect to server");
        }
        else if (error.status === 400) {
          console.log(error.error.message);
        }
      }
    );
  }

  forummodule() {
    this.route.navigate(['user/forum'], { queryParams: { 'moduleid': this.moduleid } });

  }
}
